import React, { Component } from "react";
import { Dropdown } from "react-bootstrap";
import { withTranslation } from "react-i18next";

class KnoaDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
  }

  updateKnoaDropdownClass = () => {
    const dropdownEl = document.getElementById('knoaDropdown');
    if(dropdownEl) {
      if(dropdownEl.classList.contains('dropdownContainerHide')){
        dropdownEl.classList.remove('dropdownContainerHide');
      }
      if(!dropdownEl.classList.contains('dropdownContainerShow')){
        dropdownEl.classList.add('dropdownContainerShow');
      }
    }
  };

  onToggle = (isOpen) => {
    this.updateKnoaDropdownClass();

    this.setState({ isOpen });
  };

  onMouseEnter = () => {
    this.updateKnoaDropdownClass();

    this.setState({ isOpen: true });
  };

  onMouseLeave = () => {
    this.setState({ isOpen: false });
  };

  isDrillEnabled = () => {
    const { instanceWorkbookId } = this.props;
    if (!instanceWorkbookId) return false;

    const btnDrill = document.getElementById("btnDrill" + instanceWorkbookId);
    return btnDrill && !btnDrill.classList.contains("disabled");
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    //Update dropdown after drilling
    if(prevProps.currentWorkbook.id!==this.props.currentWorkbook.id){
      const btnDrill = document.getElementById('btnDrill'+this.props.instanceWorkbookId);
      if (btnDrill && btnDrill.classList.contains('disabled')) {
        //btnDrill.classList.add('disabled');
        this.props.setDrillEnabled(false);
      }

      const drillToReportBtn = document.getElementById('knoaDropdown');
      if (drillToReportBtn) {
        if (drillToReportBtn.classList.contains('dropdownContainerShow')) {
          drillToReportBtn.classList.remove('dropdownContainerShow');
        }
        if (!drillToReportBtn.classList.contains('dropdownContainerHide')) {
          drillToReportBtn.classList.add('dropdownContainerHide');
        }
      }
      this.setState({ isOpen: false })
    }
  }

  render() {
    const {
      currentWorkbook,
      icon,
      instanceWorkbookId,
      dataRangeType,
      options: rawOptions,
      t
    } = this.props;

    const { isOpen } = this.state;

    const classValue = `dropdownContainer ${
        isOpen || this.isDrillEnabled() ? "dropdownContainerShow" : "dropdownContainerHide"
    }`;

    // Filter options if needed
    const options =
        dataRangeType === "instance"
            ? rawOptions.filter((item) => item.id === "btnDrill" + instanceWorkbookId)
            : rawOptions;

    return (
        <Dropdown
            show={isOpen}
            onToggle={this.onToggle}
            onMouseEnter={this.onMouseEnter}
            onMouseLeave={this.onMouseLeave}
            onSelect={(selectedId) => {
              const selectedOption = rawOptions.find(opt => opt.id === selectedId);
              if (selectedOption && typeof selectedOption.onClick === 'function') {
                selectedOption.onClick();
              }
            }}
        >
          <Dropdown.Toggle
              id="knoaDropdown"
              variant="default" // prevents btn-primary injection
              className={classValue}
          >
            {icon && <i className={`${icon} knoaButtonIcon`} />}
            <span className="pressText navItemText">{t('report.filter:drillToReport')}</span>
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {options.map((option, index) => (
                <Dropdown.Item
                    key={index}
                    eventKey={option.id}
                    className="knoaDropdownItem"
                    disabled={option.disabled}
                    id={option.id}
                >
              <span className="pressText navItemText">
                {currentWorkbook.workbookName.endsWith("instances")
                    ? t("instanceReport.name:" + option.workflowReportName)
                    : t("instanceReport.name:" + option.instanceReportName)}
              </span>
                </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
    );
  }
}

export default withTranslation()(KnoaDropdown);